"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5030],{

/***/ 25030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner_ProPlanUpgradeBanner; }
});

// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(752);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/User/_components/common/ProPlanUpgradeModal/index.tsx + 22 modules
var ProPlanUpgradeModal = __webpack_require__(8898);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/common/banner/ProPlanUpgradeBanner/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1977o2x8"
} : 0)( true ? {
  name: "1l345gg",
  styles: "overflow:hidden;background-image:url('/images/user/fire.png'),linear-gradient(122.77deg, #471c1c 0.78%, #27394f 69.58%);background-position:right bottom,left top;background-repeat:no-repeat,repeat;border-radius:8px"
} : 0);
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1977o2x7"
} : 0)("position:relative;overflow:hidden;width:349px;height:380px;border-radius:8px;box-shadow:", function (_ref) {
  var theme = _ref.theme;
  return theme.elevation.md;
}, ";" + ( true ? "" : 0));
var UpdateWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Wrapper,  true ? {
  target: "e1977o2x6"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";" + ( true ? "" : 0));
var UpdateImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1977o2x5"
} : 0)( true ? {
  name: "14fvduy",
  styles: "position:absolute;top:0;left:0"
} : 0);
var VersionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Wrapper,  true ? {
  target: "e1977o2x4"
} : 0)( true ? {
  name: "z1544c",
  styles: "background:#dcff90"
} : 0);
var VersionImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1977o2x3"
} : 0)( true ? {
  name: "1kri5fo",
  styles: "position:absolute;top:20px;left:0"
} : 0);
var CtaWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Wrapper,  true ? {
  target: "e1977o2x2"
} : 0)("background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, ";" + ( true ? "" : 0));
var CtaImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1977o2x1"
} : 0)( true ? {
  name: "14fvduy",
  styles: "position:absolute;top:0;left:0"
} : 0);
var TextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1977o2x0"
} : 0)("z-index:", zIndex/* Z_INDEX.onTop */.k.onTop, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/banner/ProPlanUpgradeBanner/index.tsx











var ProPlanUpgradeBanner = function ProPlanUpgradeBanner() {
  var _userInfo$subscriptio3, _userInfo$subscriptio4;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);
  var upSellBannerList = [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UpdateWrapper, {
    direction: "column",
    justifyContent: "flex-end",
    padding: 32,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpdateImageWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: "/images/banner/basic-upgrade.png",
        width: 349,
        height: 284
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "xl-semibold",
        marginBottom: 16,
        children: ["\uC138\uC77C\uC988\uD074\uB8E8 \uB9C1\uD06C\uB294 \uADF8\uB300\uB85C,", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC790\uB8CC\uB97C \uC0C8\uB86D\uAC8C \uC5C5\uB370\uC774\uD2B8 \uD574\uBCF4\uC138\uC694"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        as: "button",
        alignItems: "center",
        onClick: function onClick() {
          return setIsOpen(true);
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-medium",
          marginRight: 8,
          children: "Basic Plan\uC73C\uB85C \uC5C5\uADF8\uB808\uC774\uB4DC"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-right",
          size: 18,
          color: "black"
        })]
      })]
    })]
  }, 'first'), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VersionWrapper, {
    direction: "column",
    justifyContent: "flex-end",
    padding: 32,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VersionImageWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: "/images/banner/version-banner.png",
        width: 350,
        height: 204
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 8,
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "sm-medium",
          color: "zinc_500",
          children: "\uC5B4\uB5A4 \uC21C\uC11C\uB85C \uC790\uB8CC\uB97C \uB9CC\uB4E4\uC5B4\uC57C \uB354 \uD6A8\uACFC\uC801\uC77C\uAE4C\uC694?"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "xl-semibold",
          marginBottom: 16,
          color: "zinc_900",
          children: "\uC5EC\uB7EC \uBC84\uC804\uC73C\uB85C \uD14C\uC2A4\uD2B8 \uD574\uBCF4\uC138\uC694"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        as: "button",
        alignItems: "center",
        onClick: function onClick() {
          return setIsOpen(true);
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-medium",
          marginRight: 8,
          color: "zinc_900",
          children: "Pro Plan\uC73C\uB85C \uC5C5\uADF8\uB808\uC774\uB4DC"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-right",
          size: 18,
          color: "zinc_900"
        })]
      })]
    })]
  }, 'second'), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CtaWrapper, {
    direction: "column",
    justifyContent: "flex-end",
    padding: 32,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaImageWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: "/images/banner/cta-banner.png",
        width: 349,
        height: 215
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "xl-semibold",
        marginBottom: 16,
        children: ["PDF \uC790\uB8CC\uC5D0 \uBC14\uB85C", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uBB38\uC758 \uC591\uC2DD\uC774\uB098 \uBC84\uD2BC\uC744 \uB354\uD574\uBCF4\uC138\uC694"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        as: "button",
        alignItems: "center",
        onClick: function onClick() {
          return setIsOpen(true);
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-medium",
          marginRight: 8,
          children: "Pro Plan\uC73C\uB85C \uC5C5\uADF8\uB808\uC774\uB4DC"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:caret-right",
          size: 18,
          color: "black"
        })]
      })]
    })]
  }, "third")];
  var RandomBanner = (0,react.useMemo)(function () {
    var _userInfo$subscriptio, _userInfo$subscriptio2;

    if ((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio = userInfo.subscriptionPlan) === null || _userInfo$subscriptio === void 0 ? void 0 : _userInfo$subscriptio.name) === 'Free') {
      var random = Math.floor(Math.random() * upSellBannerList.length);
      return upSellBannerList[random];
    }

    if ((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio2 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio2 === void 0 ? void 0 : _userInfo$subscriptio2.name) === 'Basic') {
      var _random = Math.random() < 0.5 ? 1 : 2;

      return upSellBannerList[_random];
    }

    return null;
  }, [userInfo]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio3 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio3 === void 0 ? void 0 : _userInfo$subscriptio3.name) === 'Free' || (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio4 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio4 === void 0 ? void 0 : _userInfo$subscriptio4.name) === 'Basic' ? RandomBanner : null, isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal/* default */.Z, {
      onOpenChange: function onOpenChange(open) {
        setIsOpen(open);
      }
    })]
  });
};

/* harmony default export */ var banner_ProPlanUpgradeBanner = (/*#__PURE__*/react.memo(ProPlanUpgradeBanner));

/***/ })

}]);